import React, { useEffect, useState } from 'react';
import { useSelector, connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import Panel from '../CustomPanel';
import CustomTile from '../CustomTile';
import CompareChannelWise from './compareChannelWise';
import { colorsCombination } from '../../../../utils/helpers';

const AmazonRevenue = ({ rtl, callApi, currentlyShow }) => {
  const [amazonRevenues, setAmazonRevenues] = useState([]);

  const { amazonRevenueData, isAmazonRevenueLoading } = useSelector(({ dashboardReducer }) => ({
    amazonRevenueData: dashboardReducer.amazon.revenueData,
    isAmazonRevenueLoading: dashboardReducer.amazon.isLoading
  }));

  useEffect(() => {
    setAmazonRevenues(amazonRevenueData?.modal?.data);
  }, [amazonRevenueData]);

  const filteredSalesData = {};

  amazonRevenues?.map((revenue) => {
    let allFilteredRevenue = [];
    if (filteredSalesData[revenue.salesChannel]) {
      allFilteredRevenue = [...filteredSalesData[revenue.salesChannel], revenue];
      filteredSalesData[revenue.salesChannel] = allFilteredRevenue;
    } else {
      allFilteredRevenue = [revenue];
      filteredSalesData[revenue.salesChannel] = allFilteredRevenue;
    }
    return revenue
  });

  const channels = ['Amazon.co.uk', 'Amazon.ca', 'Amazon.fr', 'Amazon.de', 'Amazon.it', 'Amazon.es', 'Amazon.com'];

  let channelsData = []

  const totalCounts = {};

  channels.forEach((channel) => {
    const total = { amount: 0, orderCount: 0 };
    const data = filteredSalesData?.[channel];

    if (data?.length) {
      channelsData = channelsData.concat(data)
      data.forEach((item) => {
        total.amount += Number(item.amount);
        total.orderCount += Number(item.orderCount);
      })
    }
    totalCounts[channel] = total;
  });

  return (
    <Row className="mt-4 ">
      <Panel lg={12} title="Amazon Revenue" onRefresh={callApi}>
        {isAmazonRevenueLoading ? (
          <div
            style={{ minHeight: '200px' }}
            className="row align-items-center justify-content-center"
          >
            <SmallLoader loading={isAmazonRevenueLoading} />
          </div>
        ) : (
          <Row>
            <CustomTile value={totalCounts?.['Amazon.com']} title="Amazon US Revenue" color={colorsCombination[0]} />
            <CustomTile value={totalCounts?.['Amazon.ca']} title="Amazon CA Revenue" color={colorsCombination[1]} />
            <CustomTile value={totalCounts?.['Amazon.co.uk']} title="Amazon UK Revenue" color={colorsCombination[2]} />
            <CustomTile value={totalCounts?.['Amazon.fr']} title="Amazon FR Revenue" color={colorsCombination[3]} />
            <CustomTile value={totalCounts?.['Amazon.it']} title="Amazon IT Revenue" color={colorsCombination[4]} />
            <CustomTile value={totalCounts?.['Amazon.de']} title="Amazon DE Revenue" color={colorsCombination[5]} />
            <CustomTile value={totalCounts?.['Amazon.es']} title="Amazon SP Revenue" color={colorsCombination[6]} />

            <Col sm="12">
              <CompareChannelWise currentlyShow={currentlyShow}
                dir={rtl?.direction} filteredSalesData={filteredSalesData} channels={channels}
                data={channelsData || []} totalCounts={totalCounts} />
            </Col>
          </Row>
        )}

      </Panel>
    </Row>
  );
};

AmazonRevenue.propTypes = {
  rtl: RTLProps.isRequired,
  callApi: PropTypes.func.isRequired,
  currentlyShow: PropTypes.objectOf({ key: "", value: "" }).isRequired
};

export default connect(state => ({
  rtl: state.rtl,
}))(AmazonRevenue)

